module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "dedi_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Conversationsw_dedi_1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "epig_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Conversationsw_epig_1"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Conversationsw_chap_1"
    }
  }, [_vm._v("Chapter One: Depends on the Size of the House")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Conversationsw_chap_2"
    }
  }, [_vm._v("Chapter Two: Thar She Blows")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Conversationsw_chap_3"
    }
  }, [_vm._v("Chapter Three: “Choose a Man from Among You to Come Fight Me”")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Me and Marcus Aurelius")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Channeling Mae West")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Oh, Dr. Farrell,")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Domenic’s Underpants")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Cottage. Hardwood Floors. Fireplace.")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Who’s That Big Fat Girl, Mummy?")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Most Like a Supermodel")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: Sam")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHapter Twelve: Golden")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: We Wouldn’t Want Any Skyrocketing Going On")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: No Kids, Kay?")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: There’s Always an Erin")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: No, in Your Eyes, Lloyd Dobler")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: Pink Pastry Box o’Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen: He Never Threw Scissors")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen: Texas Steven")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty: Blue Buckets")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One: Urban Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two: El Grande es Para la Gordita")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three: An Engraved Invitation")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four: Could Eric Gagne Save Me, Too?")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five: Hemming a Degas")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six: Seabiscuit and The Corner")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven: Then Stop Acting Like One")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight: That’s One")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine: Reading Stories in Feety Pajamas")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty: Let the Games Begin")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One: The More the Merrier")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two: This Is My Area")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three: Marcus and Russell")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four: Telepathy School")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five: The Salem Witch Trials, 1692")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six: World’s Best Bride")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Seven: Caught Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Eight: It Is a Big Hat, Kate")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Nine: Dirty Little Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty: Table Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "chap_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_chap_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-One: The Super Beetle")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "ackn_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_ackn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "toc-discover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/discoverpage"
    }
  }, [_vm._v("Discover More")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "read_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_read_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Group Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toccn",
    attrs: {
      "id": "auth_bio_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Conversationsw_auth_bio_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de0a065","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversationsw_toc.vue
// module id = 63
// module chunks = 0